/** Full page reload. A seam: jsdom's `location.reload` is not stubbable in tests. */
export function reloadPage(): void {
  window.location.reload();
}
